// extracted by mini-css-extract-plugin
export default {"sidebar-content-item":"sidebar-content_sidebar-content-item__My6X2"};